export enum RoleEnum {
  USER = 'ROLE_USER',
  ADMIN = 'ROLE_ADMIN'
}